import './App.css';
import Routes from './routes';
import React, { Component }  from 'react';
import { version } from '../package.json';

class App extends Component {
  render() {
    return (
      <>
        <div className='footer'>
          <div className='empresa' id='footer_empresa'></div>
          <div className='version'>v {version}</div>
        </div>
        <div className="App">
          <Routes/>
        </div>
      </>
    );
  }
}

export default App;
